export interface Template {
    id: number;
    name: string;
    type: string;
    imageUrl: string;
    url: string;
    status: string;
}

export const typeList: string[] = ["OP", "ED"];
